import { Component, inject } from '@angular/core';
import { Location } from '@angular/common';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';

@Component({
  selector: 'app-payment-failed',
  standalone: true,
  imports: [LottieComponent],
  templateUrl: './payment-failed.component.html',
  styleUrl: './payment-failed.component.css'
})
export class PaymentFailedComponent {

  options: AnimationOptions = {
    path: 'assets/animations/failed.json',
    loop: 0
  }

  location: Location = inject(Location)

  tryAgain(){
    this.location.back();
  }
}
